module.exports = __webpack_public_path__ + "static/img/tea_app_android.d38ca47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tea_app_android.png
// module id = 9vES
// module chunks = 53